import React, { useState, useEffect } from 'react';
import styles from '../styles/Coupon.module.css';

const initialForm = { code: '', discount: '', expiry: '', status: 'Active' };

const CouponForm = ({ onSubmit, onCancel, editingCoupon }) => {
  const [form, setForm] = useState(initialForm);

  useEffect(() => {
    if (editingCoupon) setForm(editingCoupon);
    else setForm(initialForm);
  }, [editingCoupon]);

  const handleChange = e => {
    const { name, value } = e.target;
    setForm(f => ({ ...f, [name]: value }));
  };

  const handleSubmit = e => {
    e.preventDefault();
    if (!form.code || !form.discount || !form.expiry) return;
    onSubmit(form);
    setForm(initialForm);
  };

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modalContent}>
        <h3>{editingCoupon ? 'Edit Coupon' : 'Add Coupon'}</h3>
        <form onSubmit={handleSubmit}>
          <div className={styles.formGroup}>
            <label>Coupon Code</label>
            <input name="code" type="text" value={form.code} onChange={handleChange} className={styles.input} required />
          </div>
          <div className={styles.formGroup}>
            <label>Discount (%)</label>
            <input name="discount" type="number" min="1" max="100" value={form.discount} onChange={handleChange} className={styles.input} required />
          </div>
          <div className={styles.formGroup}>
            <label>Expiry Date</label>
            <input name="expiry" type="date" value={form.expiry} onChange={handleChange} className={styles.input} required />
          </div>
          <div className={styles.formGroup}>
            <label>Status</label>
            <select name="status" value={form.status} onChange={handleChange} className={styles.input}>
              <option value="Active">Active</option>
              <option value="Expired">Expired</option>
            </select>
          </div>
          <div className={styles.formActions}>
            <button type="submit" className={styles.addBtn}>{editingCoupon ? 'Update' : 'Add'}</button>
            <button type="button" className={styles.cancelBtn} onClick={onCancel}>Cancel</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CouponForm;
